// extracted by mini-css-extract-plugin
module.exports = {"holidaySet":"style-module--holiday-set--OgP4X","itemRow":"style-module--item-row--36wkd","description":"style-module--description--2w0Jv","image":"style-module--image--2KcMD"};